export const words = {
  album_title: "Albumets navn",
  rename: "Endre navn",
  no_images: "Tom",
  albums: "Album",
  email: "e-post",
  Email: "e-post",
  password: "passord",
  login: "Logg inn",
  pictures: 'Bilder',
  copy_link: "Kopier lenke",
  share_with_whatsapp: 'via WhatsApp',
  qrdownload: "Qr-kode nedlasting",
  flyerdownload: "Design av QR-kodekort",
  logout: "Logg ut",
  challenge: "Fotoutfordring",
  preparation: "Forberedelse",
  photos: "Bilder",
  challenges: "Utfordring",
  diashow: "Levende lysbildefremvisning",
  settings: "Innstillinger",
  invitation: "Invitasjon",
  of: "fra",
  comments: "Kommentarer",
  liked: "Som",
  answer: "Svar",
  minutes: " minutter",
  hours: " Timer",
  days: " Dager",
  yesterday: "I går",
  hide: "Skjul",
  choose: "Velg",
  share: "Del",
  report: "Rapport",
  delete: "Slett",
  description: "Beskrivelse av",
  enter: "Bli med",
  install: "Installere",
  or: "eller",
  event: "begivenhet",
  save: "Spar",
  cancel: "Avbryt",
  continue: "Videre",
  task: "Oppgave",
  take_photo: "Ta et bilde",
  skip: "Hopp over",
  color: "Farge",
  videos: "Videoer",
  video: 'Video',
  eur: 'Euro',
  usd: 'Dollar',
  packages: {
    free: "Gratis",
    base: "Base",
    upgrade_base_to_premium: 'Premium',
    upgrade_base_to_deluxe: 'Deluxe',
    premium: 'Premium',
    upgrade_premium_to_deluxe: 'Deluxe',
    deluxe: 'Deluxe'
  },
  1: "A",
  2: "To",
  3: "Tre",
  4: "Fire",
  5: "Fem",
  download: "Last ned",
  are: "er",
  is: "er",
  mass_download: "Masse nedlasting",
  upgrade: "Oppgradering",
  start_now: "Start",
  live_diashow: "Levende lysbildefremvisning",
  code: "Kode",
  selected: "Utvalgte",
  chosen: "valgt",
  all: 'Alle',
  picture: "Bilde",
  language: "Språk",
  languages: {
    de: "Tysk",
    en: "Engelsk",
    fr: "Fransk",
    it: "Italiensk",
    es: "Spansk"
  },
  close: "Lukk",
  edit: "Rediger",
  release: "Utgivelse",
  check: "Sjekk",
  Name: "Navn",
  area_of_work: "Industri",
  instagram_name: "Instagram-navn",
  send: "Send",
  submit: "Bekreft",
  visible: "Synlig"
};